import assign from 'object-assign';
import {combineReducers} from 'redux';
import {
  MARITAL_STATUSES_GET,
  MARITAL_STATUSES_RECEIVE
} from '../actionTypes/maritalStatuses';


export default combineReducers({
  data(state = [], action) {
    switch (action.type) {
      case MARITAL_STATUSES_RECEIVE:
        return action.maritalStatuses;
      default:
        return state;
    }
  },
  loading(state = false, action) {
    switch (action.type) {
      case MARITAL_STATUSES_GET:
        return true;
      case MARITAL_STATUSES_RECEIVE:
        return false;
      default:
        return state;
    }
  },
  byId(state = {}, action) {
    switch (action.type) {
      case MARITAL_STATUSES_RECEIVE:
        action.maritalStatuses.forEach(i => {
          state = assign({}, state, {
            [i.Marital_Status_ID]: i
          });
        });
        return state;
      default:
        return state;
    }
  },
  fetched(state = false, action) {
    switch (action.type) {
      case MARITAL_STATUSES_GET:
        return true;
      default:
        return state;
    }
  }
});


// WEBPACK FOOTER //
// ./src/reducers/maritalStatuses.js